import React from "react";
import { Sparkles, ArrowRight, Star } from "lucide-react";
import { Reveal } from "../Reveal";
import { Cloud, Bow } from "../Decor";
import { useForm } from "../../context/FormContext";
import { IMAGES } from "../../config";

export function Hero() {
  const { requestAvailability, scrollToId } = useForm();
  return (
    <section id="home" className="relative bg-sky pt-28 md:pt-36 pb-16 md:pb-24 overflow-hidden">
      <Cloud className="absolute top-24 left-[6%] w-28 md:w-40 opacity-90" />
      <Cloud className="absolute top-44 right-[30%] w-20 md:w-28 opacity-80 hidden sm:block" />
      <Cloud className="absolute bottom-10 right-[8%] w-24 md:w-36 opacity-80" />
      <Star className="absolute top-28 right-10 fill-butter hidden md:block" size={44} strokeWidth={1.5} style={{ color: "#F7D65A" }} />
      <Sparkles className="absolute bottom-24 left-6 text-berry hidden md:block" size={34} strokeWidth={2} />
      <div className="max-w-[1320px] mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-10 lg:gap-14 items-center relative">
        <div>
          <Reveal>
            <span className="sticker" data-testid="hero-badge"><Sparkles size={15} strokeWidth={2} /> Created to create · Orlando</span>
          </Reveal>
          <Reveal delay={0.05}>
            <h1 className="display text-berry text-[2.9rem] leading-[1.15] sm:text-6xl sm:leading-[1.15] lg:text-7xl lg:leading-[1.12] mt-6">
              A Creative Space for Your{" "}
              <span className="inline-block bg-butter text-berry text-[0.72em] rounded-2xl px-3 py-0.5 border-2 border-charcoal align-middle" style={{ boxShadow: "3px 3px 0 #2A1020" }}>Next Big Idea</span>
            </h1>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-lg text-charcoal/80 max-w-xl">
              DMediaClub is a creative studio and workshop space for rent in Orlando — a warm, flexible
              room for workshops, classes, content creation, team gatherings, and creative community events.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <button
                data-testid="hero-explore-btn"
                onClick={() => scrollToId("gallery")}
                className="btn inline-flex items-center justify-center gap-2 bg-butter text-charcoal border-2 border-charcoal px-7 py-4 shadow-[4px_4px_0_#2A1020]"
              >
                Explore the Space <ArrowRight size={18} strokeWidth={2} />
              </button>
              <button
                data-testid="hero-inquire-btn"
                onClick={() => requestAvailability()}
                className="btn inline-flex items-center justify-center gap-2 bg-berry text-cream border-2 border-berry px-7 py-4 hover:bg-berry-deep shadow-[4px_4px_0_#2A1020]"
              >
                Inquire About a Booking
              </button>
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.1}>
          <div className="relative">
            <div className="card-soft overflow-hidden bg-cream rotate-1">
              <img
                src={IMAGES.empty}
                alt="The DMediaClub creative studio space in Orlando"
                className="w-full h-[320px] md:h-[500px] object-cover"
              />
            </div>
            <span className="sticker absolute -bottom-4 -left-3 bg-blush rotate-[-4deg]" style={{ background: "#F7C9DC" }}>
              <Star size={14} strokeWidth={2} className="fill-charcoal" /> Studio for rent
            </span>
            <Bow className="absolute -top-5 -right-4 rotate-12 drop-shadow" size={58} />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
